import { createFileRoute, redirect } from '@tanstack/react-router';
import { DEFAULT_SNS_CONTENT_GENERATOR_ACCOUNT_ID } from '../../components/features/sns-content-generator/accounts.js';

/**
 * @graph-node {Page}
 * @graph-stack cortex-admin
 * @graph-domain Marketing
 * @graph-business `/sns-content-generator` 直打ち（accountId未指定）を既定アカウントへリダイレクトするだけのルート。
 * 実画面は `$accountId.tsx` が持つ
 * @graph-connects none
 */
export const Route = createFileRoute('/sns-content-generator/')({
  beforeLoad: () => {
    throw redirect({
      to: '/sns-content-generator/$accountId',
      params: { accountId: DEFAULT_SNS_CONTENT_GENERATOR_ACCOUNT_ID },
    }) as unknown as Error;
  },
});
